<div *ngIf="havePR"
	(click)="onSelectCell()" >
    <button type="button" class="btn btn-sm btn-outline-primary">Open Public Records</button>
</div>
